import { Check } from "lucide-react";
import VipMedallion from "./VipMedallion";
import { fmtCoins } from "@/lib/vipTiers";

export default function VipTierCard({ t, index, earned, current }) {
  return (
    <div
      data-testid={`vip-tier-card-${t.tier}`}
      style={{ animationDelay: `${index * 70}ms` }}
      className={`vip-tier-in relative card-surface p-5 flex items-center gap-4 border ${current ? `${t.border} bg-white/[0.04]` : "border-white/8"}`}
    >
      <VipMedallion tier={t.tier} size="md" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Tier {t.rank ?? index + 1}</span>
          {current && <span data-testid={`vip-tier-current-${t.tier}`} className={`text-[9px] uppercase tracking-widest border px-1.5 py-px ${t.border} ${t.text}`}>Your tier</span>}
        </div>
        <div className={`font-display text-2xl leading-tight ${t.text}`}>{t.label}</div>
        <div className="text-xs text-zinc-400 mt-0.5">
          <span className="text-white tabular-nums">{fmtCoins(t.coins)}</span> coins purchased per month
        </div>
      </div>
      {earned && (
        <span data-testid={`vip-tier-earned-${t.tier}`} className="w-7 h-7 rounded-full grid place-items-center bg-emerald-500/15 border border-emerald-400/40 text-emerald-300 shrink-0" title="Earned this month">
          <Check size={14} />
        </span>
      )}
    </div>
  );
}
